export const ff_margin_tool_placement_profile = 'ff_margin_tool_placement_profile';
export const ff_order_global_margintool = 'ff_order_global_margintool';
export const ff_order_global_margintool_ui = 'ff_order_global_margin_tool_ui';